module.exports = __webpack_public_path__ + "media/video.6e94b579.mp4";